<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row style="position: absolute; right: 12px; height: 100%">
        <v-col style="height: 100%">
          <cadastre-entity
              :definition="selectedDefinition"
              :entity="selectedEntity"
              :top-definition="toplevelDefinition"
              :in-select-mode="inSelectMode"
              @edit="startEditMode"
              @cancel="cancelEditMode"
              @save="saveEntity"
              @error="displaySnackbar"
              @add-entity="addEntity"
              @delete="deleteEntry"
              @start-create="startCreateTask"
              @create-task="createTask"
              @start-position-select="selectPosition = true"
              @end-position-select="selectPosition = false"
              ref="cadastre_entity"
          />
        </v-col>
      </v-row>
      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col sm="4" md="3" xl="3"
               style="padding-right: 0px; padding-left: 0px; padding-top: 0px; padding-bottom: 0px">
          <cadastre-side-menu :definitions="cadastres" :in-edit-mode="inEditMode" :in-select-mode="inSelectMode" :combos="combos"
                              ref="cadastre_side_menu"
                              @selection-changed="selectionChanged"
                              @edit-definition="onEditDefinition"
                              @add-entry="onDefinitionSelected"
                              @no-select="displaySnackbar('warning', 'Bitte speichern oder verwerfen Sie zuerst Ihre Änderungen.')"
                              @category-changed="changeCategory"
                              @add-definition="$refs.create_definition.showDialog(true)"
                              @create-combo="$refs.create_combo_dialog.open()"
          />
        </v-col>
        <v-col id="map_container" ref="map_container" style="padding: 0px" v-on:toggle-sidebar="toggleSideBar">
          <b-col id="sidebar_main" style="padding: 10px" class="sidebar2">
              <cadastre-filter :definition="selectedDefinition" @filter="onFilter"/>
          </b-col>
        </v-col>
      </v-row>
    </div>
    <v-snackbar
        v-model="showSnackbar"
        :color="snackbarVariant"
        bottom
        right
        rounded="pill"
        :timeout="3000"
    >
      {{ snackbarMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="showSnackbar = false"
        >
          OK
        </v-btn>
      </template>
    </v-snackbar>
    <edit-cadastre-dialog ref="edit_cadastre_dialog" :definition="selectedDefinition" @save="onChangeDefinition" @delete="deleteDefinition"/>
    <select-definition-dialog ref="select_definition_dialog" :definitions="subdefinitions"
                              @select="onDefinitionSelected"/>
    <select-aufisn-dialog ref="select_aufisn_dialog" :aufisns="subdefinitions"
                              @select="onAufisnSelected"/>
    <edit-cadastre-dialog ref="create_definition" @save="onCreateDefinition" :legrs="legrs"/>
    <create-tour-dialog ref="create_tour_dialog" :bauhof-structure="bhStructure" :is-cadastre-tour="true" @plan-tour="createTour"/>
    <create-combo ref="create_combo_dialog" :cadastres="userDefinitions" @create-combo="createCombo"/>

  </v-main>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import CadastreSideMenu from "@/views/cadastre/CadastreSideMenu.vue";
import CadastreEntity from "@/views/cadastre/CadastreEntity.vue";
import EditCadastreDialog from "@/views/cadastre/EditCadastreDialog.vue";
import SelectDefinitionDialog from "@/views/cadastre/SelectDefinitionDialog.vue";
import SelectAufisnDialog from "@/views/cadastre/SelectAufisnDialog.vue";
import CadastreFilter from "@/views/cadastre/CadastreFilter.vue";
import CreateCombo from "@/views/cadastre/CreateComboDialog.vue";
import CreateTourDialog from "@/views/aufgaben_verwaltung/CreateTourDialog.vue";

import StylesControl from 'mapbox-gl-controls/lib/styles';
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import LanguageControl from 'mapbox-gl-controls/lib/language';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';

import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import {styles} from "@/views/cadastre/cadastre_draw_style";
import {styles2} from "@/shared/free_draw";

import booleanIntersects from '@turf/boolean-intersects'
import bbox from '@turf/bbox'
import centerOfMass from '@turf/center-of-mass'
import {polygon, point, lineString, featureCollection} from '@turf/helpers'
import {encryptAES} from "@/shared/crypto";


const activeOpacity = 0.55;
const inactiveOpacity = 0.40;
const backgroundOpacity = 0.2;


class Filter {
  constructor(parent) {
    this.parent = parent;
  }

  onAdd(map) {
    this.map = map;
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
    this.button = document.createElement('button');
    this.button.innerHTML = "☰ Filter";
    this.button.onclick = () => {
      this.parent.toggleSideBar();
    };
    this.container.appendChild(this.button);
    return this.container;
  }

  onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }
}

 class TourToggle {
  constructor(parent) {
    this.parent = parent;
  }

  onAdd(map) {
    this.map = map;
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
    this.container.id = 'create_tour'
    this.container.ref = 'create_tour'
    this.container.style.background = 'green';
    this.button = document.createElement('button');
    this.button.innerHTML = "Tour erstellen";
    this.button.onclick = () => {
      this.parent.$refs.create_tour_dialog.showDialog(undefined, undefined, this.parent.selectedDefinition.name);
    };
    this.button.style.color = 'white';
    this.container.appendChild(this.button);
    return this.container;
  }

  onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }
}

export default {
  name: "cadastre",
  components: {
    CadastreSideMenu,
    CadastreEntity,
    EditCadastreDialog,
    SelectDefinitionDialog,
    SelectAufisnDialog,
    CadastreFilter,
    CreateTourDialog,
    CreateCombo
  },
  props: {
    inSelectMode: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      loader: undefined,
      cadastres: [],
      subdefinitions: [],
      query: {
        category: "CADASTRE"
      },
      geoRefPerimeter: "",
      ranOnce: false,
      currentSelection: {
        indices: [undefined, undefined, undefined, undefined],
        selectionId: undefined
      },
      toplevelDefinition: undefined,
      selectedDefinition: undefined,
      toplevelEntity: undefined,
      selectedEntity: undefined,
      inEditMode: false,
      showSnackbar: false,
      snackbarVariant: "warning",
      snackbarMessage: "",
      createAufisn: '',
      currentLayers: [],
      previousSelection: {
        indices: [undefined, undefined, undefined, undefined],
        selectionId: undefined
      },
      navopen: false,
      filterItems: [],
      activeFilter: [],
      bhStructure: [],
      legrs: [],
      selectPosition: false,
      entityIds: [],

      combos: [],
      userDefinitions: [],
    }
  },
  created() {
    this.marker = null;
    this.lat = null;
    this.lon = null;
    this.$emit('can-continue', {value: false});
    this.$nextTick(() => {
      this.parseQuery();
      this.showLoader();
      this.$http.get(
          Server_URL + '/auftragsbuch/cadastre/' + this.query.category
      ).then(this.responseOkFetch, this.responseError)
    });
  },
  mounted() {
    mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
    this.map = new mapboxgl.Map({
      container: 'map_container',
      //style: 'mapbox://styles/mapbox/outdoors-v11',
      style: 'mapbox://styles/svenpetersen/cmbkqx86200of01qw5u63fwq3',
      center: [10.244990, 50.943359],
      zoom: 6,
      minZoom: 5,
      maxZoom: 19,
      maxPitch: 0,
    });
    const languageControl = new LanguageControl({
      language: 'de',
    });
    this.map.addControl(new StylesControl({
      styles: [
        {
          label: 'Normal',
          styleName: 'Streets',
          styleUrl: 'mapbox://styles/svenpetersen/cmbkqx86200of01qw5u63fwq3',
        }, {
          label: 'Satellit',
          styleName: 'Satellite Streets',
          styleUrl: 'mapbox://styles/svenpetersen/cmbq6e7ga007701qw87nmd0gk',
        },
      ],
      onChange: () => this.map.once("style.load", this.reloadMapLayers),
    }), 'bottom-right');
    this.map.addControl(languageControl);
    //this.map.addControl(this.draw, 'top-left');
    this.map.addControl(new ZoomControl(), 'bottom-right');

    this.geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      placeholder: "Suchen",
      zoom: 19,
      language: 'de-DE',
      countries: 'de',
      marker: false,
      flyTo: true,
    });
    this.map.addControl(
        this.geocoder
    );
  },
  computed: {
    subDataPoints() {
      return this.query.category === 'AUGR' ? ['entries', 'definitions', 'entries'] : ['sub_definitions', 'entries', 'sub_cadastres'];
    }
  },
  methods: {
    createCombo({name, ids}) {
      let req = {
        name: name,
        definition_ids: ids,
      }
      this.showLoader();
      this.$http.post(
          Server_URL + '/auftragsbuch/cadastre_combo', req
      ).then((response) => {
        if (response.status === 201) {
          this.hideLoader();
          let res = response.body;
          this.combos.push(res);
          this.combos.sort((a, b) => a.name.localeCompare(b.name))
          this.$nextTick(() => {
            this.$refs.cadastre_side_menu.changeSelection(res.id);
          });
        } else {
          this.hideLoader();
          window.location = Redirect_500;
        }
      }, this.responseError);
    },
    async createTour(data) {
      let req = {
        entity_ids: this.entityIds,
        name: data.titel,
        description: await encryptAES(sessionStorage.getItem("aes"), data.description),
        legr: data.legr,
      }
      this.showLoader();
      this.$http.post(
          Server_URL + '/auftragsbuch/cadastre_tour', req
      ).then((response) => {
            if (response.status === 201) {
              this.hideLoader();
              let tourId = response.body;
              this.$router.push({path: '/auftraege/predefined_tour/' + tourId});
            } else {
                this.hideLoader();
                window.location = Redirect_500;
            }
      }, this.responseError);
    },
    startCreateTask() {
      this.selectPosition = true;
      this.calculateMarker();
    },
    createTask() {
      // /create?is_bauhof=true
      // router.push({ path: 'register', query: { plan: 'private' }})
      this.$router.push({path: '/create', query: {
          is_bauhof: true,
          entity_id: this.selectedEntity.id,
          lat: this.lat,
          lon: this.lon,
        }});
    },
    getSelected() {
      return {
        entity_id: this.selectedEntity.id,
        aufisn: this.selectedEntity.aufisn,
        augr: this.selectedEntity.augr,
        lat: this.lat,
        lon: this.lon,
      }
    },
    onSelectPosition(e) {
      this.lat = e.lngLat.lat;
      this.lon = e.lngLat.lng;

      if (this.marker === null) {
        let el = document.createElement('div');
        el.className = 'marker';

        this.marker = new mapboxgl.Marker({
          element: el,
          anchor: 'center',
        })
            .setLngLat([this.lon, this.lat])
            .addTo(this.map);
      } else {
        this.marker.setLngLat([this.lon, this.lat])
      }
    },
    deleteDefinition(id) {
      this.showLoader();
      this.$http.delete(
          Server_URL + '/auftragsbuch/cadastre_definition/' + id + "?category=" + this.query.category
      ).then(this.responseOkFetch, this.responseError);
      this.selectedDefinition = undefined;
      this.selectedEntity = undefined;
      this.toggleFilter();
    },
    deleteEntry(id) {
      this.showLoader();
      this.$http.delete(
          Server_URL + '/auftragsbuch/cadastre_entry/' + id
      ).then((response => {
        if (response.status === 204) {
          this.hideLoader();
          this.inEditMode = false;
          this.map.getCanvas().style.cursor = '';
          this.map.removeControl(this.draw);
          if (this.query.category === "AUGR") {
            // remove the new entity
            let entry = this.cadastres[this.currentSelection.indices[0]].entries[this.currentSelection.indices[1]];
            let subDefinition = entry.definitions[this.currentSelection.indices[2]];
            for (let i = 0; i < subDefinition.entries.length; i++) {
              if (subDefinition.entries[i].id === id) {
                subDefinition.entries.splice(i, 1);
                break;
              }
            }
            if (subDefinition.entries.length === 0) {
              for (let i = 0; i < entry.definitions.length; i++) {
                if (entry.definitions[i].id === subDefinition.id) {
                  entry.definitions.splice(i, 1);
                  break;
                }
              }
            }
          } else {
            let definition = this.cadastres[this.currentSelection.indices[0]];
            let subDefinition = definition.sub_definitions[this.currentSelection.indices[1]];
            let topEntry = subDefinition.entries[this.currentSelection.indices[2]];
            for (let i = 0; i < topEntry.sub_cadastres.length; i++) {
              if (topEntry.sub_cadastres[i].id === id) {
                topEntry.sub_cadastres.splice(i, 1);
                break;
              }
            }
            if (topEntry.sub_cadastres.length === 0) {
              for (let i = 0; i < subDefinition.entries.length; i++) {
                if (subDefinition.entries[i].id === topEntry.id) {
                  subDefinition.entries.splice(i, 1);
                  break;
                }
              }
            }
            if (subDefinition.entries.length === 0) {
              for (let i = 0; i < definition.sub_definitions.length; i++) {
                if (definition.sub_definitions[i].id === subDefinition.id) {
                  definition.sub_definitions.splice(i, 1);
                  break;
                }
              }
            }
          }
          for (let i = 0; i < this.geoJson.data.features.length; i++) {
            if (this.geoJson.data.features[i].properties.entity_id === id) {
              this.geoJson.data.features.splice(i, 1);
              i--;
            }
          }
          this.map.getSource('mixed-geojson').setData(this.geoJson.data);
          let prevId = this.previousSelection.selectionId;
          this.selectionChanged({
            lastSelection: {
              selectionId: id,
            },
            currentSelection: {...this.previousSelection}
          });
          this.$refs.cadastre_side_menu.setCurrentSelection(prevId);
        } else {
          this.hideLoader();
          window.location = Redirect_500;
        }
      }), this.responseError);
    },
    toggleSideBar() {
      if (!this.navopen) {
        document.getElementById("sidebar_main").style.width = "350px";
        document.getElementById("sidebar_main").style.visibility = "visible";
      } else {
        document.getElementById("sidebar_main").style.width = "0px";
        document.getElementById("sidebar_main").style.visibility = "hidden";
      }
      this.navopen = !this.navopen;
    },
    toggleFilter() {
      if (this.inSelectMode) {
        return;
      }
      this.hideNav();
      this.navopen = false;
      this.activeFilter = [];
      if (this.selectedEntity !== undefined || this.selectedDefinition === undefined || this.selectedDefinition.id !== this.toplevelDefinition.id) {
        if (this.sidebarToggle) {
          this.map.removeControl(this.sidebarToggle);
          this.sidebarToggle = undefined;
        }
        if (this.selectTourDraw) {
          this.map.removeControl(this.selectTourDraw);
          this.selectTourDraw = undefined;

          this.map.off('draw.create', this.onAreaUpdated);
          this.map.off('draw.delete', this.onAreaUpdated);
          this.map.off('draw.update', this.onAreaUpdated);
        }
        return;
      }
      if (this.createTourButton) {
        this.map.removeControl(this.createTourButton);
        this.createTourButton = undefined;
      }
      if (this.selectTourDraw) {
        this.map.removeControl(this.selectTourDraw);
        this.selectTourDraw = undefined;
        this.map.off('draw.create', this.onAreaUpdated);
        this.map.off('draw.delete', this.onAreaUpdated);
        this.map.off('draw.update', this.onAreaUpdated);
      }
      if (!this.sidebarToggle) {
        this.sidebarToggle = new Filter(this);
        this.map.addControl(this.sidebarToggle, 'top-left');
      }
      if (!this.selectTourDraw) {
        this.selectTourDraw = new MapboxDraw({
          displayControlsDefault: false,
          controls: {
            polygon: true,
            trash: true
          }
        });
        this.map.addControl(this.selectTourDraw, 'top-right');
        setTimeout(() => {
          this.map.on('draw.create', this.onAreaUpdated);
          this.map.on('draw.delete', this.onAreaUpdated);
          this.map.on('draw.update', this.onAreaUpdated);
        });
      }
    },
    onAreaUpdated(e) {
      let polygons = this.selectTourDraw.getAll();
      console.log(polygons)
      let hasInside = false;
      let layerIds = [];
      for (const layer of this.layers[this.selectedDefinition.id]) {
        let l = JSON.parse(JSON.stringify(layer));
        layerIds.push(l.id);
      }
      let l1 = this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "LineString-Outline", true, false);
      let l2 = this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "Polygon-Outline", true, false);
      layerIds.push(l1.id);
      layerIds.push(l2.id);
      this.entityIds = [];
      if (polygons.length !== 0) {
        this.entityIds = this.getIntersectingFeatures(this.map, polygons, layerIds);
        hasInside = this.entityIds !== null && this.entityIds.length > 0;
      }
      if (!hasInside) {
        if (this.createTourButton) {
          this.map.removeControl(this.createTourButton);
          this.createTourButton = undefined;
        }
      } else {
        if (!this.createTourButton) {
          this.createTourButton = new TourToggle(this);
          this.map.addControl(this.createTourButton, 'top-left');
        }
      }
    },
    onFilter(activeFilter) {
      this.activeFilter = activeFilter;
      let layerIds = [];
      for (const layer of this.layers[this.selectedDefinition.id]) {
        let l = JSON.parse(JSON.stringify(layer));
          if (l.id.startsWith('points')) {
            l.filter = this.getCurrentFilter(this.selectedDefinition.id, "Point");
          } else if (l.id.startsWith('lines')) {
            l.filter = this.getCurrentFilter(this.selectedDefinition.id, "LineString");
          } else if (l.id.startsWith('polygons')) {
            l.filter = this.getCurrentFilter(this.selectedDefinition.id,  "Polygon");
          } else if (l.id.startsWith('symbols-line-')) {
            l.filter = this.getCurrentFilterSymbolLayer(this.selectedDefinition.id, true);
          } else if (l.id.startsWith('symbols-')) {
            l.filter = this.getCurrentFilterSymbolLayer(this.selectedDefinition.id, false);
          }
        this.changeFilter(l.id, l.filter);
          layerIds.push(l.id);
        }
      let l1 = this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "LineString-Outline", true, false);
      l1.filter = this.getCurrentFilter(this.selectedDefinition.id, "LineString");
      let l2 = this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "Polygon-Outline", true, false);
      l2.filter = this.getCurrentFilter(this.selectedDefinition.id, "Polygon");
      this.changeFilter(l1.id, l1.filter);
      this.changeFilter(l2.id, l2.filter);
      layerIds.push(l1.id);
      layerIds.push(l2.id);
      // make transition to right viewport
      setTimeout(() => {
        this.getSourceFeaturesBbox(this.map, layerIds);
        console.log(this.selectedDefinition)
      }, 100);
    },
    getIntersectingFeatures(map, drawnFeatureCollection, layerIds) {
      const uniqueFeatures = new Map();

      // Iterate over each polygon the user has drawn.
      for (const drawnFeature of drawnFeatureCollection.features) {
        // Ensure we are only checking against polygons.
        if (drawnFeature.geometry.type !== 'Polygon') {
          continue;
        }

        // 1. Get the screen-space bounding box of the drawn polygon.
        const polygonBbox = bbox(drawnFeature);
        const southWest = map.project([polygonBbox[0], polygonBbox[1]]);
        const northEast = map.project([polygonBbox[2], polygonBbox[3]]);

        // 2. Query for features within that bounding box (a coarse filter).
        const featuresInBbox = map.queryRenderedFeatures([southWest, northEast], {
          layers: layerIds
        });
        console.log(featuresInBbox)
        // 3. Use Turf.js to perform a precise intersection check on the filtered features.
        for (const feature of featuresInBbox) {
          try {
            // turf.booleanIntersects handles Point, LineString, and Polygon intersections.
            const intersects = booleanIntersects(feature, drawnFeature);
            if (intersects) {
              // Create a unique key. Use feature.id if it exists, otherwise stringify geometry.
              // Vector tile features may not have a top-level `id`. Check `feature.properties` too.
              const key = feature.properties["entity_id"];

              if (!uniqueFeatures.has(key)) {
                uniqueFeatures.set(key, key);
              }
            }
          } catch (e) {
            // turf.js can sometimes throw errors with malformed geometries.
            console.error("Turf.js error on feature:", feature, e);
          }
        }
      }

      return Array.from(uniqueFeatures.keys());
    },
    getSourceFeaturesBbox(map, layerIds) {
      let bounds = null;
      if (this.selectedDefinition !== undefined && this.selectedDefinition.entries && this.selectedDefinition.entries.length > 0) {
        // iterate over the coordinates of the selected definition
        let entities = this.selectedDefinition.entries;
        bounds = new (mapboxgl.LngLatBounds);
        let foundOne = false;
        for (let i = 0; i < entities.length; i++) {
          // check if the entity applies to the active filter
          let applyFilter = true;
          for (let j = 0; j < this.activeFilter.length; j++) {
            let compare = false;
            let prop = entities[i].properties[this.activeFilter[j].property];
            let value = this.activeFilter[j].value;
            switch (this.activeFilter[j].comparator){
              case '==':
                compare = (prop === value);
                break;
              case '!=':
                compare = (prop !== value);
                break;
              case '<':
                compare = (prop < value);
                break;
              case '>':
                compare = (prop > value);
                break;
            }
            applyFilter = applyFilter && compare;
          }
          if (!applyFilter) {
            continue;
          }

          if (entities[i].locations && entities[i].locations.locations && entities[i].locations.locations.length > 0) {
            let locations = entities[i].locations.locations;
            for (let j = 0; j < locations.length; j++) {
              if (locations[j].location_type === 'POINT') {
                bounds.extend([locations[j].coordinate.lng, locations[j].coordinate.lat]);
                foundOne = true;
              } else {
                for (let k = 0; k < locations[j].coordinates.length; k++) {
                  bounds.extend([locations[j].coordinates[k].lng, locations[j].coordinates[k].lat]);
                  foundOne = true;
                }
              }
            }
          }
        }
        if (foundOne) {
          this.map.fitBounds(bounds, {padding: 50, duration: 500, maxZoom: 18});
        }
      } else if (this.selectedDefinition !== undefined && this.selectedDefinition.sub_definitions && this.selectedDefinition.sub_definitions.length > 0) {
        // iterate over the coordinates of the selected definition
        let subDefinitions = this.selectedDefinition.sub_definitions;
        bounds = new (mapboxgl.LngLatBounds);
        let foundOne = false;
        for (let i = 0; i < subDefinitions.length; i++) {
          if (subDefinitions[i].entries && subDefinitions[i].entries.length > 0) {
            for (let j = 0; j < subDefinitions[i].entries.length; j++) {
              if (subDefinitions[i].entries[j].sub_cadastres && subDefinitions[i].entries[j].sub_cadastres.length > 0) {
                for (let k = 0; k < subDefinitions[i].entries[j].sub_cadastres.length; k++) {
                  if (subDefinitions[i].entries[j].sub_cadastres[k].locations && subDefinitions[i].entries[j].sub_cadastres[k].locations.locations
                      && subDefinitions[i].entries[j].sub_cadastres[k].locations.locations.length > 0) {
                    let applyFilter = true;
                    for (let z = 0; z < this.activeFilter.length; z++) {
                      let compare = false;
                      let prop = subDefinitions[i].entries[j].sub_cadastres[k].properties[this.activeFilter[z].property];
                      let value = this.activeFilter[z].value;
                      switch (this.activeFilter[z].comparator){
                        case '==':
                          compare = (prop === value);
                          break;
                        case '!=':
                          compare = (prop !== value);
                          break;
                        case '<':
                          compare = (prop < value);
                          break;
                        case '>':
                          compare = (prop > value);
                          break;
                      }
                      applyFilter = applyFilter && compare;
                    }
                    if (!applyFilter) {
                      continue;
                    }

                    let locations = subDefinitions[i].entries[j].sub_cadastres[k].locations.locations;
                    for (let l = 0; l < locations.length; l++) {
                      if (locations[l].location_type === 'POINT') {
                        bounds.extend([locations[l].coordinate.lng, locations[l].coordinate.lat]);
                        foundOne = true;
                      } else {
                        for (let m = 0; m < locations[l].coordinates.length; m++) {
                          bounds.extend([locations[l].coordinates[m].lng, locations[l].coordinates[m].lat]);
                          foundOne = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        if (foundOne) {
          this.map.fitBounds(bounds, {padding: 50, duration: 500, maxZoom: 18});
        }
      }
      return
    },
    hideNav() {
      document.getElementById("sidebar_main").style.width = "0px";
      document.getElementById("sidebar_main").style.visibility = "hidden";
    },
    showNav() {
      document.getElementById("sidebar_main").style.width = "250px";
      document.getElementById("sidebar_main").style.visibility = "visible";
    },
    changeCategory(category) {
      this.query.category = category;
      this.showLoader();
      this.$http.get(
          Server_URL + '/auftragsbuch/cadastre/' + this.query.category
      ).then(this.responseOkFetch, this.responseError);
    },
    responseOkFetch(response) {
      if (response.status === 200) {
        this.hideLoader();
        this.subdefinitions = response.body.subdefinitions;
        this.bhStructure = response.body.bh_structure;
        this.legrs = response.body.legrs;
        this.combos = response.body.combos;
        this.userDefinitions = response.body.user_defined;
        let data = response.body.definitions;
        for (let i = 0; i < data.length; i++) {
          data[i].expanded = false;
          if (data[i][this.subDataPoints[0]] && data[i][this.subDataPoints[0]].length) {
            for (let j = 0; j < data[i][this.subDataPoints[0]].length; j++) {
              data[i][this.subDataPoints[0]][j].expanded = false;
              if (data[i][this.subDataPoints[0]][j][this.subDataPoints[1]] && data[i][this.subDataPoints[0]][j][this.subDataPoints[1]].length) {
                for (let k = 0; k < data[i][this.subDataPoints[0]][j][this.subDataPoints[1]].length; k++) {
                  data[i][this.subDataPoints[0]][j][this.subDataPoints[1]][k].expanded = false;
                  if (data[i][this.subDataPoints[0]][j][this.subDataPoints[1]][k][this.subDataPoints[2]] && data[i][this.subDataPoints[0]][j][this.subDataPoints[1]][k][this.subDataPoints[2]].length) {
                    for (let l = 0; l < data[i][this.subDataPoints[0]][j][this.subDataPoints[1]][k][this.subDataPoints[2]].length; l++) {
                      data[i][this.subDataPoints[0]][j][this.subDataPoints[1]][k][this.subDataPoints[2]][l].expanded = false;
                    }
                  }
                }
              }
            }
          }
        }
        this.cadastres = data;
        console.log(this.cadastres)
        this.geoRefPerimeter = response.body.geo_ref_perimeter;
        this.geoJson = response.body.geo_json;
        this.layers = {};
        this.computeLayers();
        if (this.map.loaded()) {
          this.initMap();
        } else {
          this.map.once('load', this.initMap);
        }
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    computeLayers() {
      for (let i = 0; i < this.cadastres.length; i++) {
        let currentC = this.cadastres[i];
        if (this.layers[currentC.id]) {
          continue;
        }
        this.layers[currentC.id] = [
          this.getLayer(currentC.id, undefined, currentC.color, "Point"),
          this.getLayer(currentC.id, undefined, currentC.color, "LineString"),
          this.getLayer(currentC.id, undefined, currentC.color, "Polygon"),
          ...this.getSymbolLayers(currentC.id, currentC.icon ? currentC.icon : "")
        ];
      }
      for (let i = 0; i < this.subdefinitions.length; i++) {
        let currentC = this.subdefinitions[i];
        if (this.layers[currentC.id]) {
          continue;
        }
        this.layers[currentC.id] = [
          this.getLayer(currentC.id, undefined, currentC.color, "Point"),
          this.getLayer(currentC.id, undefined, currentC.color, "LineString"),
          this.getLayer(currentC.id, undefined, currentC.color, "Polygon"),
          ...this.getSymbolLayers(currentC.id, currentC.icon ? currentC.icon : "")
        ];
      }
    },
    responseOkTrap(response) {
      this.hideLoader();
      if (response.status === 200 || response.status === 204) {
        // do nothing
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      console.log(response)
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_Login;
      }
    },
    showLoader() {
      this.hideLoader();
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    parseQuery() {
      let query = this.$route.query;
      if (query.category) {
        this.query = {
          category: query.category,
        }
      }
    },
    reset() {
      this.currentSelection = {
        indices: [undefined, undefined, undefined, undefined],
        selectionId: undefined
      };
      this.selectedDefinition = undefined;
      this.selectedEntity = undefined;
      this.inEditMode = false;
      this.currentLayers = [];
      this.previousSelection = {
        indices: [undefined, undefined, undefined, undefined],
        selectionId: undefined
      };
      this.resetMap();
    },
    resetMap() {
      const allLayers = this.map.getStyle().layers;
      allLayers.forEach(layer => {
        if (layer.source === 'mixed-geojson') {
          // A strong indicator of a user-added layer
          if (this.map.getLayer(layer.id)) {
            this.map.removeLayer(layer.id);
          }
        }
      });
      if (this.map.getSource('mixed-geojson')) {
        this.map.removeSource('mixed-geojson');
      }
      this.map.off('click', this.onClick);
    },
    initMap() {
      if (this.map === undefined) {
        return;
      }
      this.reset();
      this.map.resize();
      if (this.geoRefPerimeter !== "") {
        setTimeout(() => {
          let sw = this.geoRefPerimeter.split("||")[0].split(",");
          let ne = this.geoRefPerimeter.split("||")[1].split(",");
          this.map.fitBounds([
            [parseFloat(sw[0]), parseFloat(sw[1])], // southwestern corner of the bounds
            [parseFloat(ne[0]), parseFloat(ne[1])] // northeastern corner of the bounds
          ], {padding: 100, duration: 500});
        });
      }
      if (this.geoJson !== undefined && this.geoJson !== null) {
        this.map.addSource('mixed-geojson', this.geoJson);
        let layerIds = [];
        for (const layerId in this.layers) {
          for (const layer of this.layers[layerId]) {
            this.map.on('mouseenter', layer.id, () => {
              if (this.inEditMode) {
                return
              }
              this.map.getCanvas().style.cursor = 'pointer';
            });
            this.map.on('mouseleave', layer.id, () => {
              if (this.inEditMode) {
                return
              }
              this.map.getCanvas().style.cursor = '';
            });
          }
        }
        this.map.on('click', this.onClick);
      }
      this.selectionChanged({lastSelection: null, currentSelection: {
        indices: [undefined, undefined, undefined, undefined],
            selectionId: undefined
      }});
    },
    onClick(e) {
      if (this.selectPosition) {
        this.onSelectPosition(e);
        return;
      }
      let layers = [];
      for (let i = 0; i < this.currentLayers.length; i++) {
        layers.push('points' + this.currentLayers[i]);
        layers.push('lines' + this.currentLayers[i]);
        layers.push('polygons' + this.currentLayers[i]);
        layers.push('symbols-line-' + this.currentLayers[i]);
        layers.push('symbols-' + this.currentLayers[i]);
      }
      if (this.selectedDefinition !== undefined && this.selectedEntity === undefined) {
        layers.push('points' + this.selectedDefinition.id);
        layers.push('lines' + this.selectedDefinition.id);
        layers.push('polygons' + this.selectedDefinition.id);
        layers.push('symbols-line-' + this.selectedDefinition.id);
        layers.push('symbols-' + this.selectedDefinition.id);
      }
      if (this.inEditMode || layers.length === 0) {
        return
      }
      const features = this.map.queryRenderedFeatures(e.point, {
        layers: layers
      });
      if (features && features.length > 0) {
        let indices = this.findSelection(this.cadastres, features[0].properties.cadastre_id, features[0].properties.entity_id, this.toplevelDefinition.id);
        if (indices.length > 0) {
          this.selectionChanged({
            lastSelection: {
              selectionId: this.selectedDefinition ? this.selectedDefinition.id : undefined,
            },
            currentSelection: {
              indices: indices,
              selectionId: features[0].properties.cadastre_id + (features[0].properties.entity_id ? "-" + features[0].properties.entity_id : "")
            }
          });
          let id = features[0].properties.entity_id;
          if (this.query.category !== 'AUGR' && indices.length === 3) {
            id = this.toplevelDefinition.id + '$' + id;
          }
          this.$refs.cadastre_side_menu.setCurrentSelection(id);
        }
      }
    },
    reloadMapLayers() {
      if (this.geoJson !== undefined && this.geoJson !== null) {
        this.map.addSource('mixed-geojson', this.geoJson);
        for (let i = 0; i < this.currentLayers.length; i++) {
          for (const layer of this.layers[this.currentLayers[i]]) {
            this.map.addLayer(layer, "admin-0-boundary-disputed");
          }
        }
      }
      if (this.selectedDefinition !== undefined && this.selectedEntity === undefined) {
        for (const layer of this.layers[this.selectedDefinition.id]) {
          this.map.addLayer(layer, "admin-0-boundary-disputed");
        }
        this.changePaint(
            'points' + this.selectedDefinition.id,
            this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "Point", true).paint
        );
        this.changePaint(
            'lines' + this.selectedDefinition.id,
            this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "LineString", true).paint
        );
        this.changePaint(
            'polygons' + this.selectedDefinition.id,
            this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "Polygon", true).paint
        );
        this.map.moveLayer('polygons' + this.selectedDefinition.id);
        this.map.moveLayer('lines' + this.selectedDefinition.id);
        this.map.moveLayer('points' + this.selectedDefinition.id);
        this.map.addLayer(
            this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "LineString-Outline", true)
        );
        this.map.addLayer(
            this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "Polygon-Outline", true)
        );
        this.map.moveLayer('symbols-line-' + this.selectedDefinition.id);
        this.map.moveLayer('symbols-' + this.selectedDefinition.id);
      } else if (this.selectedDefinition !== undefined && this.selectedEntity !== undefined) {


        // todo set aufisn filter for sub layers

        if (!this.inEditMode) {
          this.map.addLayer(
              this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "Point", true)
          );
          this.map.addLayer(
              this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "LineString", true)
          );
          this.map.addLayer(
              this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "Polygon", true)
          );
          this.map.addLayer(
              this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "LineString-Outline", true)
          );
          this.map.addLayer(
              this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "Polygon-Outline", true)
          );
          let symbolLayers = this.getSymbolLayers(this.selectedDefinition.id, this.selectedDefinition.icon ? this.selectedDefinition.icon : "", this.selectedEntity.id, true);
          for (const layer of symbolLayers) {
            this.map.addLayer(layer);
          }
        } else {
          let collection = this.draw.getAll();
          this.map.removeControl(this.draw);
          this.draw = new MapboxDraw({
            displayControlsDefault: false,
            controls: {
              point: true,
              line_string: true,
              polygon: true,
              trash: true,
            },
            styles: styles
          });
          this.map.addControl(this.draw, 'top-left');
          this.draw.set(collection);
        }
      } else if (this.query.category !== "AUGR" && this.query.category !== "CADASTRE") {
        for (var prop in this.layers) {
          let alreadyAdded = false;
          for (let i = 0; i < this.currentLayers.length; i++) {
            if (this.currentLayers[i] === prop) {
              alreadyAdded = true;
              break;
            }
          }
          if (!alreadyAdded) {
            alreadyAdded = true;
            for (let i = 0; i < this.cadastres.length; i++) {
              if (this.cadastres[i].id === prop) {
                alreadyAdded = false;
                break;
              }
            }
          }
          if (!alreadyAdded) {
            for (const layer of this.layers[prop]) {
              this.map.addLayer(layer, "admin-0-boundary-disputed");
            }
          }
        }
      }
    },
    onSidebarToggle() {
      this.map.resize();
    },
    findSelection(definitions, cadastreId, entityId, topLevelDefinitionId = undefined) {
      if (this.query.category === 'AUGR') {
        let selectionIndices = [];
        if (definitions === undefined || definitions === null || definitions.length === 0) {
          return selectionIndices;
        }
        for (let i = 0; i < definitions.length; i++) {
          if (definitions[i].id === cadastreId) {
            selectionIndices.push(i);
            definitions[i].expanded = this.getRandomInt();
            if (definitions[i].entries && definitions[i].entries.length > 0) {
              for (let j = 0; j < definitions[i].entries.length; j++) {
                if (definitions[i].entries[j].id === entityId) {
                  selectionIndices.push(j);
                  definitions[i].entries[j].expanded = this.getRandomInt();
                  return selectionIndices;
                }
              }
            }
            return [];
          } else {
            if (definitions[i].entries && definitions[i].entries.length > 0) {
              for (let j = 0; j < definitions[i].entries.length; j++) {
                let subSelection = this.findSelection(definitions[i].entries[j].definitions, cadastreId, entityId);
                if (subSelection.length > 0) {
                  selectionIndices.push(i);
                  selectionIndices.push(j);
                  definitions[i].entries[j].expanded = this.getRandomInt();
                  definitions[i].expanded = this.getRandomInt();
                  selectionIndices = selectionIndices.concat(subSelection);
                  return selectionIndices;
                }
              }
            }
          }
        }
        return selectionIndices;
      } else {
        for (let i = 0; i < definitions.length; i++) {
          if (definitions[i].sub_definitions && definitions[i].id === topLevelDefinitionId) {
            definitions[i].expanded = this.getRandomInt();
            for (let j = 0; j < definitions[i].sub_definitions.length; j++) {
              if (definitions[i].sub_definitions[j].id === entityId) {
                definitions[i].sub_definitions[j].expanded = this.getRandomInt();
                return [i, j];
              }
              if (definitions[i].sub_definitions[j].entries) {
                for (let k = 0; k < definitions[i].sub_definitions[j].entries.length; k++) {
                  if (definitions[i].sub_definitions[j].entries[k].id === entityId) {
                    definitions[i].sub_definitions[j].expanded = this.getRandomInt();
                    definitions[i].sub_definitions[j].entries[k].expanded = this.getRandomInt();
                    return [i, j, k];
                  }
                  if (definitions[i].sub_definitions[j].entries[k].sub_cadastres) {
                    for (let l = 0; l < definitions[i].sub_definitions[j].entries[k].sub_cadastres.length; l++) {
                      if (definitions[i].sub_definitions[j].entries[k].sub_cadastres[l].id === entityId) {
                        definitions[i].sub_definitions[j].expanded = this.getRandomInt();
                        definitions[i].sub_definitions[j].entries[k].expanded = this.getRandomInt();
                        definitions[i].sub_definitions[j].entries[k].sub_cadastres[l].expanded = this.getRandomInt();
                        return [i, j, k, l];
                      }
                    }
                  }
                }
              }
            }
          }
        }
        return [];
      }
    },
    getRandomInt() {
      return Math.floor(Math.random() * 1000000) + 1;
    },
    selectionChanged({lastSelection, currentSelection}) {
      console.log("selection")
      if (this.marker) {
        this.marker.remove();
        this.lat = 0.0;
        this.lon = 0.0;
        this.marker = undefined;
        this.selectPosition = false;
      }
      this.previousSelection = this.currentSelection;
      this.currentSelection = currentSelection;
      //if (lastSelection.selectionId) {
        const allLayers = this.map.getStyle().layers;
        allLayers.forEach(layer => {
          if (layer.source === 'mixed-geojson') {
            // A strong indicator of a user-added layer
            if (this.map.getLayer(layer.id)) {
              this.map.removeLayer(layer.id);
            }
          }
        });
      //}
      this.currentLayers = [];
      // apply the new selection
      this.selectedEntity = undefined;
      this.selectedDefinition = undefined;
      this.toplevelDefinition = undefined;
      this.toplevelEntity = undefined;
      if (currentSelection.selectionId === undefined && false) {
        this.toggleFilter();
        this.$emit('can-continue', {value: false});
        return;
      }
      let current = {definitions: this.cadastres};
      if (this.query.category === "AUGR") {
        for (let i = 0; i < currentSelection.indices.length; i++) {
          if (currentSelection.indices[i] === undefined) {
            break;
          }
          if (i === 0) {
            this.toplevelDefinition = current.definitions[currentSelection.indices[i]];
          }
          if (i === 1) {
            this.toplevelEntity = current.entries[currentSelection.indices[i]];
          }
          if (i % 2 === 0) {
            current = current.definitions[currentSelection.indices[i]];
            this.selectedDefinition = current;
            this.selectedEntity = undefined;
          } else {
            current = current.entries[currentSelection.indices[i]];
            this.selectedEntity = current;
          }
        }
      } else {
        if (currentSelection.indices[3] !== undefined) {
          this.selectedEntity = current.definitions[currentSelection.indices[0]].sub_definitions[currentSelection.indices[1]].entries[currentSelection.indices[2]].sub_cadastres[currentSelection.indices[3]];
          this.selectedDefinition = current.definitions[currentSelection.indices[0]];
          this.toplevelDefinition = current.definitions[currentSelection.indices[0]].sub_definitions[currentSelection.indices[1]];
          this.toplevelEntity = current.definitions[currentSelection.indices[0]].sub_definitions[currentSelection.indices[1]].entries[currentSelection.indices[2]];
        } else if (currentSelection.indices[2] !== undefined) {
          this.selectedEntity = current.definitions[currentSelection.indices[0]].sub_definitions[currentSelection.indices[1]].entries[currentSelection.indices[2]];
          this.selectedDefinition = current.definitions[currentSelection.indices[0]].sub_definitions[currentSelection.indices[1]];
          this.toplevelDefinition = current.definitions[currentSelection.indices[0]];
        } else if (currentSelection.indices[1] !== undefined) {
          this.selectedDefinition = current.definitions[currentSelection.indices[0]].sub_definitions[currentSelection.indices[1]];
          this.toplevelDefinition = current.definitions[currentSelection.indices[0]];
        } else if (currentSelection.indices[0] !== undefined) {
          this.selectedDefinition = current.definitions[currentSelection.indices[0]];
          this.toplevelDefinition = current.definitions[currentSelection.indices[0]];
        }
      }
      this.toggleFilter();
      console.log(this.selectedDefinition)
      console.log(this.query)
      if (this.selectedDefinition !== undefined && this.selectedEntity === undefined) {
        if (this.toplevelDefinition && this.toplevelEntity && this.toplevelDefinition.id !== this.selectedDefinition.id) {
          this.map.addLayer(
              this.getLayer(this.toplevelDefinition.id, this.toplevelEntity.id, this.toplevelDefinition.color, "Point", false, true)
              , "admin-0-boundary-disputed");
          this.map.addLayer(
              this.getLayer(this.toplevelDefinition.id, this.toplevelEntity.id, this.toplevelDefinition.color, "LineString", false, true)
              , "admin-0-boundary-disputed");
          this.map.addLayer(
              this.getLayer(this.toplevelDefinition.id, this.toplevelEntity.id, this.toplevelDefinition.color, "Polygon", false, true)
              , "admin-0-boundary-disputed");
          this.map.addLayer(
              this.getLayer(this.toplevelDefinition.id, this.toplevelEntity.id, this.toplevelDefinition.color, "LineString-Outline", false, true)
              , "admin-0-boundary-disputed");
          this.map.addLayer(
              this.getLayer(this.toplevelDefinition.id, this.toplevelEntity.id, this.toplevelDefinition.color, "Polygon-Outline", false, true)
              , "admin-0-boundary-disputed");
          let symbolLayers = this.getSymbolLayers(this.toplevelDefinition.id, this.toplevelDefinition.icon ? this.toplevelDefinition.icon : "", this.toplevelEntity.id, false, true);
          for (let i = 0; i < symbolLayers.length; i++) {
            this.map.addLayer(symbolLayers[i], "admin-0-boundary-disputed");
          }
        }
        let aufisns = undefined;
        for (const layer of this.layers[this.selectedDefinition.id]) {
          let l = JSON.parse(JSON.stringify(layer));
          if (this.toplevelDefinition.id !== this.selectedDefinition.id) {
            if (this.query.category === "AUGR") {
              aufisns = [this.toplevelEntity.aufisn];
            } else {
              aufisns = this.selectedDefinition.entries.map(c => c.aufisn);
            }
            if (l.id.startsWith('points')) {
              l.filter = this.getFilter(this.selectedDefinition.id, undefined, "Point", true, false, aufisns);
            } else if (l.id.startsWith('lines')) {
              l.filter = this.getFilter(this.selectedDefinition.id, undefined, "LineString", true, false, aufisns);
            } else if (l.id.startsWith('polygons')) {
              l.filter = this.getFilter(this.selectedDefinition.id, undefined, "Polygon", true, false, aufisns);
            } else if (l.id.startsWith('symbols-line-')) {
              l.filter = this.getFilterSymbolLayer(this.selectedDefinition.id, true, undefined, true, false, aufisns);
            } else if (l.id.startsWith('symbols-')) {
              l.filter = this.getFilterSymbolLayer(this.selectedDefinition.id, false, undefined, true, false, aufisns);
            }
          } else {
            if (l.id.startsWith('points')) {
              l.filter = this.getCurrentFilter(this.selectedDefinition.id, "Point");
            } else if (l.id.startsWith('lines')) {
              l.filter = this.getCurrentFilter(this.selectedDefinition.id, "LineString");
            } else if (l.id.startsWith('polygons')) {
              l.filter = this.getCurrentFilter(this.selectedDefinition.id,  "Polygon");
            } else if (l.id.startsWith('symbols-line-')) {
              l.filter = this.getCurrentFilterSymbolLayer(this.selectedDefinition.id, true);
            } else if (l.id.startsWith('symbols-')) {
              l.filter = this.getCurrentFilterSymbolLayer(this.selectedDefinition.id, false);
            }
          }
          this.map.addLayer(l);
        }
        this.changePaint(
            'points' + this.selectedDefinition.id,
            this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "Point", true).paint
        );
        this.changePaint(
            'lines' + this.selectedDefinition.id,
            this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "LineString", true).paint
        );
        this.changePaint(
            'polygons' + this.selectedDefinition.id,
            this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "Polygon", true).paint
        );
        if (this.toplevelDefinition.id !== this.selectedDefinition.id) {
          this.map.addLayer(
              this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "LineString-Outline", true, false, aufisns)
          );
          this.map.addLayer(
              this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "Polygon-Outline", true, false, aufisns)
          );
        } else {
          let l1 = this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "LineString-Outline", true, false, aufisns);
          l1.filter = this.getCurrentFilter(this.selectedDefinition.id, "LineString");
          let l2 = this.getLayer(this.selectedDefinition.id, undefined, this.selectedDefinition.color, "Polygon-Outline", true, false, aufisns);
          l2.filter = this.getCurrentFilter(this.selectedDefinition.id, "Polygon");
          this.map.addLayer(l1);
          this.map.addLayer(l2);
        }
        this.map.moveLayer('symbols-line-' + this.selectedDefinition.id);
        this.map.moveLayer('symbols-' + this.selectedDefinition.id);
        if (this.toplevelDefinition.id !== this.selectedDefinition.id && this.query.category !== "AUGR") {
          this.currentLayers = [this.toplevelDefinition.id];
          for (let i = 0; i < this.currentLayers.length; i++) {
            for (const layer of this.layers[this.currentLayers[i]]) {
              let l = JSON.parse(JSON.stringify(layer));
              if (l.id.startsWith('points')) {
                l.filter = this.getFilter(this.currentLayers[i], undefined, "Point", false, false, aufisns)
              } else if (l.id.startsWith('lines')) {
                l.filter = this.getFilter(this.currentLayers[i], undefined, "LineString", false, false, aufisns)
              } else if (l.id.startsWith('polygons')) {
                l.filter = this.getFilter(this.currentLayers[i], undefined, "Polygon", false, false, aufisns)
              } else if (l.id.startsWith('symbols-line-')) {
                l.filter = this.getFilterSymbolLayer(this.currentLayers[i], true, undefined, false, false, aufisns);
              } else if (l.id.startsWith('symbols-')) {
                l.filter = this.getFilterSymbolLayer(this.currentLayers[i], false, undefined, false, false, aufisns);
              }
              this.map.addLayer(l);
            }
          }
        }
      } else if (this.selectedDefinition !== undefined && this.selectedEntity !== undefined) {
        if (this.toplevelDefinition && this.toplevelEntity && this.toplevelDefinition.id !== this.selectedDefinition.id) {
          this.map.addLayer(
              this.getLayer(this.toplevelDefinition.id, this.toplevelEntity.id, this.toplevelDefinition.color, "Point", false, true)
              , "admin-0-boundary-disputed");
          this.map.addLayer(
              this.getLayer(this.toplevelDefinition.id, this.toplevelEntity.id, this.toplevelDefinition.color, "LineString", false, true)
              , "admin-0-boundary-disputed");
          this.map.addLayer(
              this.getLayer(this.toplevelDefinition.id, this.toplevelEntity.id, this.toplevelDefinition.color, "Polygon", false, true)
              , "admin-0-boundary-disputed");
          this.map.addLayer(
              this.getLayer(this.toplevelDefinition.id, this.toplevelEntity.id, this.toplevelDefinition.color, "LineString-Outline", false, true)
              , "admin-0-boundary-disputed");
          this.map.addLayer(
              this.getLayer(this.toplevelDefinition.id, this.toplevelEntity.id, this.toplevelDefinition.color, "Polygon-Outline", false, true)
              , "admin-0-boundary-disputed");
          let symbolLayers = this.getSymbolLayers(this.toplevelDefinition.id, this.toplevelDefinition.icon ? this.toplevelDefinition.icon : "", this.toplevelEntity.id, false, true);
          for (let i = 0; i < symbolLayers.length; i++) {
            this.map.addLayer(symbolLayers[i], "admin-0-boundary-disputed");
          }
          // add the background layers for the other entries for this definition and aufisn
          this.map.addLayer(
              this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "Point", false, true, [this.selectedEntity.aufisn], true)
          );
          this.map.addLayer(
              this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "LineString", false, true, [this.selectedEntity.aufisn], true)
          );
          this.map.addLayer(
              this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "Polygon", false, true, [this.selectedEntity.aufisn], true)
          );
          this.map.addLayer(
              this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "LineString-Outline", false, true, [this.selectedEntity.aufisn], true)
          );
          this.map.addLayer(
              this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "Polygon-Outline", false, true, [this.selectedEntity.aufisn], true)
          );
          symbolLayers = this.getSymbolLayers(this.selectedDefinition.id, this.selectedDefinition.icon ? this.selectedDefinition.icon : "", this.selectedEntity.id, false, true, [this.selectedEntity.aufisn], true);
          for (let i = 0; i < symbolLayers.length; i++) {
            this.map.addLayer(symbolLayers[i]);
          }
        }

        this.map.addLayer(
            this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "Point", true)
        );
        this.map.addLayer(
            this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "LineString", true)
        );
        this.map.addLayer(
            this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "Polygon", true)
        );
        this.map.addLayer(
            this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "LineString-Outline", true)
        );
        this.map.addLayer(
            this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "Polygon-Outline", true)
        );
        let symbolLayers = this.getSymbolLayers(this.selectedDefinition.id, this.selectedDefinition.icon ? this.selectedDefinition.icon : "", this.selectedEntity.id, true);
        for (const layer of symbolLayers) {
          this.map.addLayer(layer);
        }

        if (this.selectedEntity.definitions && this.selectedEntity.definitions.length > 0) {
          this.currentLayers = this.selectedEntity.definitions.map(d => d.id);
          for (let i = 0; i < this.currentLayers.length; i++) {
            for (const layer of this.layers[this.currentLayers[i]]) {
              let l = JSON.parse(JSON.stringify(layer));
              if (l.id.startsWith('points')) {
                l.filter = this.getFilter(this.currentLayers[i], undefined, "Point", false, false, [this.selectedEntity.aufisn])
              } else if (l.id.startsWith('lines')) {
                l.filter = this.getFilter(this.currentLayers[i], undefined, "LineString", false, false, [this.selectedEntity.aufisn])
              } else if (l.id.startsWith('polygons')) {
                l.filter = this.getFilter(this.currentLayers[i], undefined, "Polygon", false, false, [this.selectedEntity.aufisn])
              } else if (l.id.startsWith('symbols-line-')) {
                l.filter = this.getFilterSymbolLayer(this.currentLayers[i], true, undefined, false, false, [this.selectedEntity.aufisn]);
              } else if (l.id.startsWith('symbols-')) {
                l.filter = this.getFilterSymbolLayer(this.currentLayers[i], false, undefined, false, false, [this.selectedEntity.aufisn]);
              }
              this.map.addLayer(l);
            }
          }
        }
        if (this.toplevelDefinition.id !== this.selectedDefinition.id && this.query.category !== "AUGR") {
          this.currentLayers = [this.toplevelDefinition.id];
          for (let i = 0; i < this.currentLayers.length; i++) {
            for (const layer of this.layers[this.currentLayers[i]]) {
              let l = JSON.parse(JSON.stringify(layer));
              if (l.id.startsWith('points')) {
                l.filter = this.getFilter(this.currentLayers[i], undefined, "Point", false, false, [this.selectedEntity.aufisn])
              } else if (l.id.startsWith('lines')) {
                l.filter = this.getFilter(this.currentLayers[i], undefined, "LineString", false, false, [this.selectedEntity.aufisn])
              } else if (l.id.startsWith('polygons')) {
                l.filter = this.getFilter(this.currentLayers[i], undefined, "Polygon", false, false, [this.selectedEntity.aufisn])
              } else if (l.id.startsWith('symbols-line-')) {
                l.filter = this.getFilterSymbolLayer(this.currentLayers[i], true, undefined, false, false, [this.selectedEntity.aufisn]);
              } else if (l.id.startsWith('symbols-')) {
                l.filter = this.getFilterSymbolLayer(this.currentLayers[i], false, undefined, false, false, [this.selectedEntity.aufisn]);
              }
              this.map.addLayer(l);
            }
          }
        }
      } else if (this.query.category !== "AUGR" && this.query.category !== "CADASTRE") {
        console.log("here")
        for (var prop in this.layers) {
          let alreadyAdded = false;
          for (let i = 0; i < this.currentLayers.length; i++) {
            if (this.currentLayers[i] === prop) {
              alreadyAdded = true;
              break;
            }
          }
          if (!alreadyAdded) {
            alreadyAdded = true;
            for (let i = 0; i < this.cadastres.length; i++) {
              if (this.cadastres[i].id === prop) {
                alreadyAdded = false;
                break;
              }
            }
          }
          if (!alreadyAdded) {
            for (const layer of this.layers[prop]) {
              this.map.addLayer(layer, "admin-0-boundary-disputed");
            }
          }
        }
      }
      if (this.selectedEntity && this.selectedEntity.id === 'new') {
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$refs.cadastre_entity.setEditMode();
          });
        })
      } else if (this.selectedEntity && this.inSelectMode) {
        this.$emit('can-continue', {value: true});
        this.calculateMarker();
      }
      this.changeBounds();
    },
    calculateMarker() {
      if (!this.selectedEntity.locations || !this.selectedEntity.locations.locations || this.selectedEntity.locations.locations.length === 0) {
        return
      } else {
        let locations = this.selectedEntity.locations.locations;
        let features = [];
        for (let i = 0; i < locations.length; i++) {
          if (locations[i].location_type === 'POINT') {
            features.push(point([locations[i].coordinate.lng, locations[i].coordinate.lat]));
          } else {
            let coordinates = []
            for (let j = 0; j < locations[i].coordinates.length; j++) {
              coordinates.push([locations[i].coordinates[j].lng, locations[i].coordinates[j].lat]);
            }
            if (locations[i].location_type === 'POLYGON') {
              features.push(polygon([coordinates]));
            } else  {
              features.push(lineString(coordinates));
            }
          }
        }
        if (features.length === 0) {
          return;
        }
        let f = featureCollection(features);
        let center = centerOfMass(f);
        if(center) {
          this.lat = center.geometry.coordinates[1];
          this.lon = center.geometry.coordinates[0];
          let el = document.createElement('div');
          el.className = 'marker';
          this.marker = new mapboxgl.Marker({
            element: el,
            anchor: 'center',
          })
              .setLngLat([this.lon, this.lat])
              .addTo(this.map);
        }
      }
    },
    getLayer(cadastreId, entityId, color, geometryType, isActive = false, isBackground = false, aufisns = undefined, isBackgroundEntity = false) {
      let layer = {
        source: 'mixed-geojson',
        filter: this.getFilter(cadastreId, entityId, geometryType.replace("-Outline", ""), isActive, isBackground, aufisns, isBackgroundEntity),
      };
      switch (geometryType) {
        case "Point":
          layer.type = 'circle';
          layer.paint = {
            //'circle-radius': isActive ? 8 : 6,
            'circle-radius': [
              'interpolate',
              ['linear'],
              ['zoom'],
              5, 1,    // small circles at low zoom
              10, 2,
              14, 4,
              16, 6,
              18, 10   // large circles when zoomed in
            ],
            'circle-color': color,
            'circle-opacity': isBackground ? backgroundOpacity : isActive ? activeOpacity : inactiveOpacity,
            'circle-stroke-color': '#000000',
            'circle-stroke-opacity': isBackground ? backgroundOpacity : isActive ? 1.0 : inactiveOpacity,
            'circle-stroke-width': [
              'interpolate',
              ['linear'],
              ['zoom'],
              5, 0,
              10, isActive ? 0.2 : 0.2,
              14, isActive ? 0.5 : 0.5,
              16, isActive ? 1 : 0.5,
              18, isActive ? 2 : 1
            ],
          };
          layer.id = 'points' + (isActive && entityId ? entityId : cadastreId);
          break;
        case "LineString":
          layer.type = 'line';
          layer.paint = {
            'line-color': color,
            'line-width': [
              'interpolate',
              ['linear'],
              ['zoom'],
              5, 0.5,
              10, 1.5,
              14, 3,
              16, 6,
              18, 12
            ],
            'line-opacity': isBackground ? backgroundOpacity : isActive ? activeOpacity : inactiveOpacity,
          };
          layer.id = 'lines' + (isActive && entityId ? entityId : cadastreId);
          break;
        case "LineString-Outline":
          layer.type = 'line';
          layer.paint = {
            'line-color': '#000000',
            'line-width': [
              'interpolate',
              ['linear'],
              ['zoom'],
              5, 0,
              10, 0.1,
              14, 0.3,
              16, 0.4,
              18, 1
            ],
            'line-gap-width': [
              'interpolate',
              ['linear'],
              ['zoom'],
              5, 0.5,
              10, 1.5,
              14, 3,
              16, 6,
              18, 12
            ],
            'line-opacity': isBackground ? backgroundOpacity : 1.0,
          };
          layer.id = 'line-outline' + (isActive && entityId ? entityId : cadastreId);
          break;
        case "Polygon":
          layer.type = 'fill';
          layer.paint = {
            'fill-color': color,
            'fill-opacity': isBackground ? backgroundOpacity : isActive ? activeOpacity : inactiveOpacity,
            'fill-outline-color': isActive ? '#000000' : color,
          };
          layer.id = 'polygons' + (isActive && entityId ? entityId : cadastreId);
          break;
        case "Polygon-Outline":
          layer.type = 'line';
          layer.paint = {
            'line-color': '#000000',
            'line-width': [
              'interpolate',
              ['linear'],
              ['zoom'],
              5, 0,
              10, 0.1,
              14, 0.3,
              16, 0.4,
              18, 2
            ],
            'line-opacity': isBackground ? backgroundOpacity : 1.0,
          };
          layer.id = 'polygon-outline' + (isActive && entityId ? entityId : cadastreId);
          break;
      }
      if (isBackgroundEntity) {
        layer.id = 'background-entity-' + geometryType;
      } else if (isBackground) {
        layer.id = 'background-' + geometryType;
      }
      return layer;
    },
    getFilter(cadastreId, entityId, geometryType, isActive = false, isBackground = false, aufisns, isBackgroundEntity = false) {
      let filter = [
        "all",
        ["==", ["geometry-type"], geometryType],
        ["==", ["get", "cadastre_id"], cadastreId]
      ];
      if (entityId !== undefined && entityId !== null) {
        filter.push([(isActive || (isBackground && !isBackgroundEntity)) ? "==" : "!=", ["get", "entity_id"], entityId]);
      }
      if (aufisns !== undefined && aufisns !== null && aufisns.length && aufisns.length > 0) {
        filter.push([
          "in",
          ["get", "aufisn"],
          ["literal", aufisns]
        ]);
      }
      return filter;
    },
    getCurrentFilter(cadastreId, geometryType) {
      let filter = [
        "all",
        ["==", ["geometry-type"], geometryType],
        ["==", ["get", "cadastre_id"], cadastreId]
      ];
      for (let i = 0; i < this.activeFilter.length; i++) {
        filter.push([
          this.activeFilter[i].comparator,
          ["get", this.activeFilter[i].property],
          this.activeFilter[i].value
        ]);
      }
      return filter;
    },
    getSymbolLayers(cadastreId, symbol, entityId = undefined, isActive = false, isBackground = false, aufisns, isBackgroundEntity = false) {
      if (symbol !== "") {
        symbol = String.fromCodePoint(parseInt(symbol, 16));
      }
      return [{
        "id": isBackground ? (isBackgroundEntity ? "background-entity-symbols-line" : "background-symbols-line") : "symbols-line-" + (isActive && entityId ? entityId : cadastreId),
        "type": "symbol",
        "source": "mixed-geojson",
        "filter": this.getFilterSymbolLayer(cadastreId, true, entityId, isActive, isBackground, aufisns, isBackgroundEntity),
        "min-zoom": 16,
        "layout": {
          "text-field": symbol,
          "text-font": ["Material Symbols Rounded Medium"],
          "text-size": [
            'interpolate',
            ['linear'],
            ['zoom'],
            14, 10,
            18, 16
          ],
          "symbol-placement": "line-center",
          "text-offset": [0, 0.09],
          "text-rotation-alignment": "viewport",
          "text-allow-overlap": true,
        },
        "paint": {
          "text-color": "#282828",
          "text-opacity": isBackground ? 0.3 : 1.0,
          "text-halo-width":
              [
                'interpolate',
                ['linear'],
                ['zoom'],
                14, 0.5,
                18, 1
              ],
          "text-halo-color": "#ffffff",
          "text-halo-blur": 2,
        }
      }, {
        "id": isBackground ? (isBackgroundEntity ? "background-entity-symbols" : "background-symbols") : "symbols-" + (isActive && entityId ? entityId : cadastreId),
        "type": "symbol",
        "source": "mixed-geojson",
        "filter": this.getFilterSymbolLayer(cadastreId, false, entityId, isActive, isBackground, aufisns, isBackgroundEntity),
        "min-zoom": 16,
        "layout": {
          "text-field": symbol,
          "text-font": ["Material Symbols Rounded Medium"],
          "text-size": [
            'interpolate',
            ['linear'],
            ['zoom'],
            14, 10,
            18, 16
          ],
          "symbol-placement": "point",
          "text-offset": [0, 0.09],
          "text-rotation-alignment": "viewport",
          "text-allow-overlap": true,
        },
        "paint": {
          "text-color": "#282828",
          "text-opacity": isBackground ? 0.3 : 1.0,
          "text-halo-width":
              [
                'interpolate',
                ['linear'],
                ['zoom'],
                14, 0.5,
                18, 1
              ],
          "text-halo-color": "#ffffff",
          "text-halo-blur": 2,
        }
      }];
    },
    getFilterSymbolLayer(cadastreId, isLine = false, entityId = undefined, isActive = false, isBackground = false, aufisns, isBackgroundEntity = false) {
      let filter = [
        "all",
        [isLine ? "==" : "!=", ["geometry-type"], "LineString"],
        ["==", ["get", "cadastre_id"], cadastreId]
      ];
      if (entityId !== undefined && entityId !== null) {
        filter.push([(isActive || (isBackground && !isBackgroundEntity)) ? "==" : "!=", ["get", "entity_id"], entityId]);
      }
      if (aufisns !== undefined && aufisns !== null && aufisns.length && aufisns.length > 0) {
        filter.push([
          "in",
          ["get", "aufisn"],
          ["literal", aufisns]
        ]);
      }
      return filter;
    },
    getCurrentFilterSymbolLayer(cadastreId, isLine = false) {
      let filter = [
        "all",
        [isLine ? "==" : "!=", ["geometry-type"], "LineString"],
        ["==", ["get", "cadastre_id"], cadastreId]
      ];
      for (let i = 0; i < this.activeFilter.length; i++) {
        filter.push([
          this.activeFilter[i].comparator,
          ["get", this.activeFilter[i].property],
          this.activeFilter[i].value
        ]);
      }
      return filter;
    },
    changePaint(layerId, paint) {
      if (this.map.getLayer(layerId)) {
        for (const [property, value] of Object.entries(paint)) {
          this.map.setPaintProperty(layerId, property, value);
        }
      }
    },
    changeFilter(layerId, filter) {
      if (this.map.getLayer(layerId)) {
        this.map.setFilter(layerId, filter);
      }
    },
    changeSymbol(layerId, symbol) {
      if (this.map.getLayer(layerId)) {
        this.map.setLayoutProperty(layerId, 'text-field', symbol);
      }
    },
    changeBounds() {
      let bounds = null;
      if (this.selectedEntity !== undefined) {
        let locations = [];
        if (this.selectedEntity.id === 'new' && this.query.category !== "AUGR" && this.toplevelEntity.locations && this.selectedEntity.locations.locations) {
          locations = this.toplevelEntity.locations.locations;
        } else if (!this.selectedEntity.locations || !this.selectedEntity.locations.locations || this.selectedEntity.locations.locations.length === 0) {
          return
        } else {
          locations = this.selectedEntity.locations.locations;
        }
        bounds = new (mapboxgl.LngLatBounds);
        let foundOne = false;
        for (let i = 0; i < locations.length; i++) {
          if (locations[i].location_type === 'POINT') {
            bounds.extend([locations[i].coordinate.lng, locations[i].coordinate.lat]);
            foundOne = true;
          } else {
            for (let j = 0; j < locations[i].coordinates.length; j++) {
              bounds.extend([locations[i].coordinates[j].lng, locations[i].coordinates[j].lat]);
              foundOne = true;
            }
          }
        }
        if (foundOne) {
          this.map.fitBounds(bounds, {padding: 50, duration: 500, maxZoom: 18});
        }
      } else if (this.selectedDefinition !== undefined && this.selectedDefinition.entries && this.selectedDefinition.entries.length > 0) {
        // iterate over the coordinates of the selected definition
        let entities = this.selectedDefinition.entries;
        bounds = new (mapboxgl.LngLatBounds);
        let foundOne = false;
        for (let i = 0; i < entities.length; i++) {
          if (entities[i].locations && entities[i].locations.locations && entities[i].locations.locations.length > 0) {
            let locations = entities[i].locations.locations;
            for (let j = 0; j < locations.length; j++) {
              if (locations[j].location_type === 'POINT') {
                bounds.extend([locations[j].coordinate.lng, locations[j].coordinate.lat]);
                foundOne = true;
              } else {
                for (let k = 0; k < locations[j].coordinates.length; k++) {
                  bounds.extend([locations[j].coordinates[k].lng, locations[j].coordinates[k].lat]);
                  foundOne = true;
                }
              }
            }
          }
        }
        if (foundOne) {
          this.map.fitBounds(bounds, {padding: 50, duration: 500, maxZoom: 18});
        }
      } else if (this.selectedDefinition !== undefined && this.selectedDefinition.sub_definitions && this.selectedDefinition.sub_definitions.length > 0) {
        // iterate over the coordinates of the selected definition
        let subDefinitions = this.selectedDefinition.sub_definitions;
        bounds = new (mapboxgl.LngLatBounds);
        let foundOne = false;
        for (let i = 0; i < subDefinitions.length; i++) {
          if (subDefinitions[i].entries && subDefinitions[i].entries.length > 0) {
            for (let j = 0; j < subDefinitions[i].entries.length; j++) {
              if (subDefinitions[i].entries[j].sub_cadastres && subDefinitions[i].entries[j].sub_cadastres.length > 0) {
                for (let k = 0; k < subDefinitions[i].entries[j].sub_cadastres.length; k++) {
                  if (subDefinitions[i].entries[j].sub_cadastres[k].locations && subDefinitions[i].entries[j].sub_cadastres[k].locations.locations
                      && subDefinitions[i].entries[j].sub_cadastres[k].locations.locations.length > 0) {
                    let locations = subDefinitions[i].entries[j].sub_cadastres[k].locations.locations;
                    for (let l = 0; l < locations.length; l++) {
                      if (locations[l].location_type === 'POINT') {
                        bounds.extend([locations[l].coordinate.lng, locations[l].coordinate.lat]);
                        foundOne = true;
                      } else {
                        for (let m = 0; m < locations[l].coordinates.length; m++) {
                          bounds.extend([locations[l].coordinates[m].lng, locations[l].coordinates[m].lat]);
                          foundOne = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        if (foundOne) {
          this.map.fitBounds(bounds, {padding: 50, duration: 500, maxZoom: 18});
        }
      } else {
        /*bounds = new (mapboxgl.LngLatBounds);
        let foundOne = false;
        console.log("here")
        console.log(this.cadastres)
        for (let i = 0; i < this.cadastres.length; i++) {
          if (!this.cadastres[i].sub_definitions) {
            continue
          }
          let entities = this.cadastres[i].entries;
          for (let i = 0; i < entities.length; i++) {
            if (entities[i].locations && entities[i].locations.locations && entities[i].locations.locations.length > 0) {
              let locations = entities[i].locations.locations;
              for (let j = 0; j < locations.length; j++) {
                if (locations[j].location_type === 'POINT') {
                  bounds.extend([locations[j].coordinate.lng, locations[j].coordinate.lat]);
                  foundOne = true;
                } else {
                  for (let k = 0; k < locations[j].coordinates.length; k++) {
                    bounds.extend([locations[j].coordinates[k].lng, locations[j].coordinates[k].lat]);
                    foundOne = true;
                  }
                }
              }
            }
          }
        }
        if (foundOne) {
          this.map.fitBounds(bounds, {padding: 50, duration: 500, maxZoom: 18});
        }*/
      }
    },
    onEditDefinition(definitionId) {
      this.$nextTick(() => {
        this.$refs.edit_cadastre_dialog.showDialog();
      });
    },
    onChangeDefinition(definition) {
      if (definition === undefined || definition === null) {
        return;
      }

      this.showLoader();
      this.$http.patch(
          Server_URL + '/auftragsbuch/cadastre_definition', definition
      ).then(this.responseOkTrap, this.responseError)

      // update the definitions in the list
      for (let i = 0; i < this.cadastres.length; i++) {
        this.changeDefinition(this.cadastres[i], definition);
      }
      // update the layers
      let symbol = definition.icon ? definition.icon : "";
      if (symbol !== "") {
        symbol = String.fromCodePoint(parseInt(symbol, 16));
      }
      let changeLayers = this.layers[definition.id];
      if (changeLayers && changeLayers.length > 0) {
        for (let i = 0; i < changeLayers.length; i++) {
          switch (changeLayers[i].type) {
            case "circle":
              this.layers[definition.id][i] = this.getLayer(definition.id, undefined, definition.color, "Point", false);
              this.changePaint(changeLayers[i].id, this.getLayer(definition.id, undefined, definition.color, "Point", true).paint);
              break;
            case "line":
              this.layers[definition.id][i] = this.getLayer(definition.id, undefined, definition.color, "LineString", false);
              this.changePaint(changeLayers[i].id, this.getLayer(definition.id, undefined, definition.color, "LineString", true).paint);
              break;
            case "fill":
              this.layers[definition.id][i] = this.getLayer(definition.id, undefined, definition.color, "Polygon", false);
              this.changePaint(changeLayers[i].id, this.getLayer(definition.id, undefined, definition.color, "Polygon", true).paint);
              break;
            case "symbol":
              this.layers[definition.id][i]["layout"]["text-field"] = symbol;
              this.changeSymbol(changeLayers[i].id, symbol);
              break;
          }
        }
      }
    },
    changeDefinition(definition, {id, name, properties, properties_order, next_property_key, color, icon}) {
      if (definition.id === id) {
        definition.name = name;
        definition.properties = properties;
        definition.properties_order = properties_order;
        definition.next_property_key = next_property_key;
        definition.color = color;
        definition.icon = icon;
      } else if (definition.entries && definition.entries.length > 0) {
        for (let i = 0; i < definition.entries.length; i++) {
          if (definition.entries[i].definitions && definition.entries[i].definitions.length > 0) {
            for (let j = 0; j < definition.entries[i].definitions.length; j++) {
              this.changeDefinition(definition.entries[i].definitions[j], {
                id,
                name,
                properties,
                properties_order,
                next_property_key,
                color,
                icon
              });
            }
          }
        }
      } else if (definition.sub_definitions && definition.sub_definitions.length > 0) {
        for (let i = 0; i < definition.sub_definitions.length; i++) {
          this.changeDefinition(definition.sub_definitions[i], {
            id,
            name,
            properties,
            properties_order,
            next_property_key,
            color,
            icon
          });
        }
      }
    },
    startEditMode(entityId) {
      this.inEditMode = true;
      this.draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          point: true,
          line_string: true,
          polygon: true,
          trash: true,
        },
        styles: styles
      });
      this.map.getCanvas().style.cursor = '';
      this.map.addControl(this.draw, 'top-left');
      this.map.removeLayer('points' + this.selectedEntity.id);
      this.map.removeLayer('lines' + this.selectedEntity.id);
      this.map.removeLayer('polygons' + this.selectedEntity.id);
      this.map.removeLayer('line-outline' + this.selectedEntity.id);
      this.map.removeLayer('polygon-outline' + this.selectedEntity.id);
      this.map.removeLayer('symbols-line-' + this.selectedEntity.id);
      this.map.removeLayer('symbols-' + this.selectedEntity.id);
      // collect all features for this entity
      this.editFeatures = [];
      for (let i = 0; i < this.geoJson.data.features.length; i++) {
        if (this.geoJson.data.features[i].properties.entity_id === this.selectedEntity.id) {
          this.editFeatures.push(this.geoJson.data.features[i]);
        }
      }
      // add the features to the draw control
      this.draw.set({
        type: 'FeatureCollection',
        features: this.editFeatures
      });
    },
    cancelEditMode(entityId) {
      this.inEditMode = false;
      this.map.getCanvas().style.cursor = '';
      this.map.removeControl(this.draw);
      if (entityId === 'new') {
        if (this.query.category === "AUGR") {
          // remove the new entity
          let entry = this.cadastres[this.currentSelection.indices[0]].entries[this.currentSelection.indices[1]];
          let subDefinition = entry.definitions[this.currentSelection.indices[2]];
          for (let i = 0; i < subDefinition.entries.length; i++) {
            if (subDefinition.entries[i].id === 'new') {
              subDefinition.entries.splice(i, 1);
              break;
            }
          }
          if (subDefinition.entries.length === 0) {
            for (let i = 0; i < entry.definitions.length; i++) {
              if (entry.definitions[i].id === subDefinition.id) {
                entry.definitions.splice(i, 1);
                break;
              }
            }
          }
        } else {
          let definition = this.cadastres[this.currentSelection.indices[0]];
          let subDefinition = definition.sub_definitions[this.currentSelection.indices[1]];
          let topEntry = subDefinition.entries[this.currentSelection.indices[2]];
          for (let i = 0; i < topEntry.sub_cadastres.length; i++) {
            if (topEntry.sub_cadastres[i].id === 'new') {
              topEntry.sub_cadastres.splice(i, 1);
              break;
            }
          }
          if (topEntry.sub_cadastres.length === 0) {
            for (let i = 0; i < subDefinition.entries.length; i++) {
              if (subDefinition.entries[i].id === topEntry.id) {
                subDefinition.entries.splice(i, 1);
                break;
              }
            }
          }
          if (subDefinition.entries.length === 0) {
            for (let i = 0; i < definition.sub_definitions.length; i++) {
              if (definition.sub_definitions[i].id === subDefinition.id) {
                definition.sub_definitions.splice(i, 1);
                break;
              }
            }
          }
        }
        let prevId = this.previousSelection.selectionId;
        this.selectionChanged({
          lastSelection: {
            selectionId: 'new',
          },
          currentSelection: {...this.previousSelection}
        });
        this.$refs.cadastre_side_menu.setCurrentSelection(prevId);
      } else {
        this.map.addLayer(
            this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "Point", true)
        );
        this.map.addLayer(
            this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "LineString", true)
        );
        this.map.addLayer(
            this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "Polygon", true)
        );
        this.map.addLayer(
            this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "LineString-Outline", true)
        );
        this.map.addLayer(
            this.getLayer(this.selectedDefinition.id, this.selectedEntity.id, this.selectedDefinition.color, "Polygon-Outline", true)
        );
        let symbolLayers = this.getSymbolLayers(this.selectedDefinition.id, this.selectedDefinition.icon ? this.selectedDefinition.icon : "", this.selectedEntity.id, true);
        for (const layer of symbolLayers) {
          this.map.addLayer(layer);
        }
      }
    },
    saveEntity(entity) {
      entity.locations.locations = [];
      let collection = this.draw.getAll();
      let deletedIds = [];
      for (let i = 0; i < this.editFeatures.length; i++) {
        if (collection.features.findIndex(f => f.id === this.editFeatures[i].id) === -1) {
          deletedIds.push(this.editFeatures[i].id);
        }
      }
      for (let i = 0; i < collection.features.length; i++) {
        let feature = collection.features[i];
        if (this.editFeatures.findIndex(f => f.id === feature.id) === -1) {
          feature.id = ''; // new feature
        }
        let location;
        switch (feature.geometry.type) {
          case "Point":
            location = {
              location_type: 'POINT',
              coordinate: {
                lat: feature.geometry.coordinates[1],
                lng: feature.geometry.coordinates[0]
              }
            };
            break;
          case "LineString":
            location = {
              location_type: 'LINESTRING',
              coordinates: []
            };
            for (let j = 0; j < feature.geometry.coordinates.length; j++) {
              location.coordinates.push({
                lat: feature.geometry.coordinates[j][1],
                lng: feature.geometry.coordinates[j][0]
              });
            }
            break;
          case "Polygon":
            location = {
              location_type: 'POLYGON',
              coordinates: []
            };
            for (let j = 0; j < feature.geometry.coordinates[0].length; j++) {
              location.coordinates.push({
                lat: feature.geometry.coordinates[0][j][1],
                lng: feature.geometry.coordinates[0][j][0]
              });
            }
            break;
        }
        location.id = feature.id;
        entity.locations.locations.push(location);
      }
      this.showLoader();
      if (entity.id === 'new') {
        entity.id = '';
        this.$http.post(
            Server_URL + '/auftragsbuch/cadastre_entry', entity
        ).then(this.responseEditEntityOk, this.responseError)
      } else {
        this.$http.patch(
            Server_URL + '/auftragsbuch/cadastre_entry', {entry: entity, deleted_locations: deletedIds}
        ).then(this.responseEditEntityOk, this.responseError)
      }
    },
    displaySnackbar(variant, message) {
      this.snackbarVariant = variant;
      this.snackbarMessage = message;
      this.showSnackbar = true;
    },
    responseEditEntityOk(response) {
      this.hideLoader();
      if (response.status === 200 || response.status === 201 || response.status === 204) {
        let isNew = this.selectedEntity.id === 'new';
        this.selectedEntity = response.body;
        // update the geoJson source
        if (!isNew) {
          for (let i = 0; i < this.geoJson.data.features.length; i++) {
            if (this.geoJson.data.features[i].properties.entity_id === this.selectedEntity.id) {
              this.geoJson.data.features.splice(i, 1);
              i--;
            }
          }
        }
        if (this.query.category === "AUGR" || this.currentSelection.indices[3] !== undefined) {
          // update the entity in the cadastre list
          let entity = null;
          if (this.currentSelection.indices[3] !== undefined && this.query.category === "AUGR") {
            entity = this.cadastres[this.currentSelection.indices[0]].entries[this.currentSelection.indices[1]].definitions[this.currentSelection.indices[2]].entries[this.currentSelection.indices[3]];
          } else if (this.currentSelection.indices[3] !== undefined) {
            entity = this.cadastres[this.currentSelection.indices[0]].sub_definitions[this.currentSelection.indices[1]].entries[this.currentSelection.indices[2]].sub_cadastres[this.currentSelection.indices[3]];
          } else {
            entity = this.cadastres[this.currentSelection.indices[0]].entries[this.currentSelection.indices[1]];
          }
          entity.id = this.selectedEntity.id;
          entity.name = this.selectedEntity.name;
          entity.description = this.selectedEntity.description;
          entity.last_worked_at = this.selectedEntity.last_worked_at;
          entity.estimated_next_work = this.selectedEntity.estimated_next_work;
          entity.locations = this.selectedEntity.locations;
          entity.properties = this.selectedEntity.properties;
          if (this.currentSelection.indices[3] !== undefined && this.query.category === "AUGR") {
            // sort the entries
            this.cadastres[this.currentSelection.indices[0]].entries[this.currentSelection.indices[1]].definitions[this.currentSelection.indices[2]].entries.sort((a, b) => a.name.localeCompare(b.name));
          } else if (this.currentSelection.indices[3] !== undefined) {
            this.cadastres[this.currentSelection.indices[0]].sub_definitions[this.currentSelection.indices[1]].entries[this.currentSelection.indices[2]].sub_cadastres.sort((a, b) => a.name.localeCompare(b.name));
          } else {
            // sort the entries
            this.cadastres[this.currentSelection.indices[0]].entries.sort((a, b) => a.name.localeCompare(b.name));
          }
          this.currentSelection.indices = this.findSelection(this.cadastres, this.selectedDefinition.id, this.selectedEntity.aufisn, this.toplevelDefinition.id)
          this.$refs.cadastre_side_menu.setCurrentSelection(this.selectedEntity.id);
        } else {
          this.updateAUGREntries()
          this.$refs.cadastre_side_menu.setCurrentSelection(this.toplevelDefinition.id + "$" + this.selectedEntity.id);
        }
        // add the locations of the entity to the geoJson source
        if (this.selectedEntity.locations.locations) {
          for (let i = 0; i < this.selectedEntity.locations.locations.length; i++) {
            let location = this.selectedEntity.locations.locations[i];
            let feature = {
              type: 'Feature',
              id: location.id,
              properties: {
                entity_id: this.selectedEntity.id,
                cadastre_id: this.selectedDefinition.id,
                aufisn: this.selectedEntity.aufisn,
              },
              geometry: {
                coordinates: []
              }
            };
            if (location.location_type === 'POINT') {
              feature.geometry.type = "Point";
              feature.geometry.coordinates = [location.coordinate.lng, location.coordinate.lat];
            } else if (location.location_type === 'LINESTRING') {
              feature.geometry.type = "LineString";
              for (let j = 0; j < location.coordinates.length; j++) {
                feature.geometry.coordinates.push([location.coordinates[j].lng, location.coordinates[j].lat]);
              }
            } else if (location.location_type === 'POLYGON') {
              feature.geometry.coordinates.push([]);
              feature.geometry.type = "Polygon";
              for (let j = 0; j < location.coordinates.length; j++) {
                feature.geometry.coordinates[0].push([location.coordinates[j].lng, location.coordinates[j].lat]);
              }
            }
            this.geoJson.data.features.push(feature);
          }
        }
        // update source
        this.map.getSource('mixed-geojson').setData(this.geoJson.data);
        this.$nextTick(() => {
          this.$refs.cadastre_entity.cancelEdit();
        })
      } else {
        //window.location = Redirect_500;
      }
    },
    updateAUGREntries() {
      for (let i = 0; i < this.cadastres.length; i++) {
        if (this.cadastres[i].sub_definitions && this.cadastres[i].sub_definitions.length) {
          for (let j = 0; j < this.cadastres[i].sub_definitions.length; j++) {
            if (this.cadastres[i].sub_definitions[j].entries && this.cadastres[i].sub_definitions[j].entries.length) {
              for (let k = 0; k < this.cadastres[i].sub_definitions[j].entries.length; k++) {
                let entity = this.cadastres[i].sub_definitions[j].entries[k];
                entity.description = this.selectedEntity.description;
                entity.last_worked_at = this.selectedEntity.last_worked_at;
                entity.estimated_next_work = this.selectedEntity.estimated_next_work;
                entity.locations = this.selectedEntity.locations;
                entity.properties = this.selectedEntity.properties;
              }
            }
          }
        }
      }
    },
    addEntity(aufisn, definitionId, augrDefinition = undefined, aufisnEntry = undefined) {
      this.createAufisn = aufisn;
      if (definitionId) {
        if (!augrDefinition && !aufisnEntry) {
          if (this.toplevelDefinition.category !== "AUGR") {
            augrDefinition = this.selectedDefinition;
            aufisnEntry = this.selectedEntity;
          } else {
            augrDefinition = this.toplevelDefinition;
            aufisnEntry = this.toplevelEntity;
          }
        }
        this.onDefinitionSelected(definitionId, undefined, augrDefinition, aufisnEntry);
      } else {
        this.$refs.select_definition_dialog.open()
      }
    },
    onDefinitionSelected(selected, aufisn = undefined, augrDefinition = undefined, aufisnEntry = undefined) {
      if (aufisn) {
        this.createAufisn = aufisn;
      }
      if (selected === 'new') {
        // create a new one
        this.$refs.create_definition.showDialog();
      } else if (this.query.category === "AUGR") {
        // if the definition is not already in the sub list, add it and select it, add a new entry below it
        // open the new entry
        let definition = this.subdefinitions.find(d => d.id === selected);
        if (!definition) {
          return
        }
        definition = JSON.parse(JSON.stringify(definition));
        definition.expanded = false;
        let entry = {
          id: 'new',
          aufisn: this.createAufisn,
          definition_id: definition.id,
          definition_name: definition.name,
          name: definition.name,
          description: "",
          properties: {},
          last_worked_at: null,
          estimated_next_work: null,
          locations: {
            locations: []
          },
        };
        definition.entries = [entry];

        // check to which level the entry needs to be added
        if (this.currentSelection.indices[2] === undefined) {
          // check if the currentEntity has the definition already
          if (this.selectedEntity && this.selectedEntity.definitions) {
            let existingDefinition = this.selectedEntity.definitions.find(d => d.id === definition.id);
            if (existingDefinition) {
              // add the new entry to the existing definition
              existingDefinition.entries.push(entry);
              // sort the entries by name
              existingDefinition.entries.sort((a, b) => a.name.localeCompare(b.name));
            } else {
              // add the new definition to the current entity
              this.selectedEntity.definitions.push(definition);
              // sort the definitions by name
              this.selectedEntity.definitions.sort((a, b) => a.name.localeCompare(b.name));
              // add the new entry to the new definition

            }
          } else {
            // create a new entity with the selected definition
            this.selectedEntity.definitions = [definition];
          }
          let indices = this.findSelection(this.cadastres, definition.id, "new", this.toplevelDefinition.id);
          if (indices.length > 0) {
            this.selectionChanged({
              lastSelection: {
                selectionId: this.selectedDefinition ? this.selectedDefinition.id : undefined,
              },
              currentSelection: {
                indices: indices,
                selectionId: definition.id + "-new"
              }
            });
            this.$refs.cadastre_side_menu.setCurrentSelection("new");
          }
        } else {
          // we already have the definition added
          this.selectedDefinition.expanded = this.getRandomInt();
          this.selectedDefinition.entries.push(entry);
          this.selectedDefinition.entries.sort((a, b) => a.name.localeCompare(b.name));
          this.selectionChanged({
            lastSelection: {
              selectionId: this.selectedDefinition ? this.selectedDefinition.id : undefined,
            },
            currentSelection: {
              indices: [this.currentSelection.indices[0], this.currentSelection.indices[1], this.currentSelection.indices[2], 0],
              selectionId: definition.id + "-new"
            }
          });
          this.$refs.cadastre_side_menu.setCurrentSelection("new");
        }
      } else {
        if (!aufisn) {
          // we came from a definition, so we need to user to select a aufisn first
          this.$refs.select_aufisn_dialog.open(selected);
          return;
        }
        // if the definition is not already in the sub list, add it and select it, add a new entry below it
        // open the new entry
        let definition = this.cadastres.find(d => d.id === selected);
        if (!definition) {
          return
        }
        let entry = {
          id: 'new',
          aufisn: this.createAufisn,
          definition_id: definition.id,
          definition_name: definition.name,
          name: definition.name,
          description: "",
          properties: {},
          last_worked_at: null,
          estimated_next_work: null,
          locations: {
            locations: []
          },
        };
        this.selectedDefinition.expanded = this.getRandomInt();
        augrDefinition.expanded = this.getRandomInt();
        aufisnEntry.expanded = this.getRandomInt();
        aufisnEntry.sub_cadastres.push(entry);
        aufisnEntry.sub_cadastres.sort((a, b) => a.name.localeCompare(b.name));
          this.selectionChanged({
            lastSelection: {
              selectionId: this.selectedDefinition ? this.selectedDefinition.id : undefined,
            },
            currentSelection: {
              indices: this.findSelection(this.cadastres, definition.id, "new", this.toplevelDefinition.category !== 'AUGR' ? this.toplevelDefinition.id : this.selectedDefinition.id),
              selectionId: definition.id + "-new"
            }
          });
          this.$refs.cadastre_side_menu.setCurrentSelection("new");
      }
    },
    onAufisnSelected(entry) {
      entry.sub_cadastres = [];
      let augrEntry = undefined;
      for (let i = 0; i < this.subdefinitions.length; i++) {
        if (this.subdefinitions[i].entries) {
          for (let j = 0; j < this.subdefinitions[i].entries.length; j++) {
            if (this.subdefinitions[i].entries[j].id === entry.id) {
              augrEntry = JSON.parse(JSON.stringify(this.subdefinitions[i]));
              augrEntry.entries = [entry];
              break;
            }
          }
        }
      }
      if (!augrEntry) {
        return
      }
      // check if we have the augr entry already under our top level definition
      let existingEntry = this.toplevelDefinition.sub_definitions ? this.toplevelDefinition.sub_definitions.find(e => e.id === entry.id) : undefined;
      if (!existingEntry) {
        // add the augr entry to the top level definition
        if (this.toplevelDefinition.sub_definitions) {
          this.toplevelDefinition.sub_definitions.push(augrEntry);
        } else {
          this.toplevelDefinition.sub_definitions = [augrEntry];
        }
        this.toplevelDefinition.sub_definitions.sort((a, b) => a.name.localeCompare(b.name));
        this.onDefinitionSelected(this.toplevelDefinition.id, entry.aufisn, augrEntry, entry);
        return;
      }
      if (!existingEntry.entries) {
        existingEntry.entries = [];
      }
      // check if the entry is already in the existing entry
      let existingAufisnEntry = existingEntry.entries ?  existingEntry.entries.find(e => e.id === entry.id) : undefined;
      if (!existingEntry) {
        // add the augr entry to the top level definition
        if (existingEntry.entries) {
          existingEntry.entries.push(entry);
        } else {
          existingEntry.entries = [entry];
        }
        existingEntry.entries.sort((a, b) => a.name.localeCompare(b.name));
        this.onDefinitionSelected(this.toplevelDefinition.id, entry.aufisn, existingEntry, entry);
        return;
      }
      this.onDefinitionSelected(this.toplevelDefinition.id, entry.aufisn, existingEntry, existingAufisnEntry);
    },
    onCreateDefinition(definition) {
      definition.id = "";
      this.showLoader();
      this.$http.post(
          Server_URL + '/auftragsbuch/cadastre_definition', definition
      ).then((response) => {
        this.hideLoader();
        if (response.status === 200 || response.status === 201 || response.status === 205) {
          if (response.status === 205) {
            this.subdefinitions = response.body.subdefinitions;
            let data = response.body.definitions;
            for (let i = 0; i < data.length; i++) {
              data[i].expanded = false;
              if (data[i][this.subDataPoints[0]] && data[i][this.subDataPoints[0]].length) {
                for (let j = 0; j < data[i][this.subDataPoints[0]].length; j++) {
                  data[i][this.subDataPoints[0]][j].expanded = false;
                  if (data[i][this.subDataPoints[0]][j][this.subDataPoints[1]] && data[i][this.subDataPoints[0]][j][this.subDataPoints[1]].length) {
                    for (let k = 0; k < data[i][this.subDataPoints[0]][j][this.subDataPoints[1]].length; k++) {
                      data[i][this.subDataPoints[0]][j][this.subDataPoints[1]][k].expanded = false;
                      if (data[i][this.subDataPoints[0]][j][this.subDataPoints[1]][k][this.subDataPoints[2]] && data[i][this.subDataPoints[0]][j][this.subDataPoints[1]][k][this.subDataPoints[2]].length) {
                        for (let l = 0; l < data[i][this.subDataPoints[0]][j][this.subDataPoints[1]][k][this.subDataPoints[2]].length; l++) {
                          data[i][this.subDataPoints[0]][j][this.subDataPoints[1]][k][this.subDataPoints[2]][l].expanded = false;
                        }
                      }
                    }
                  }
                }
              }
            }
            this.cadastres = data;
            this.geoJson = response.body.geo_json;
            this.layers = {};
            this.computeLayers();
            if (this.map.loaded()) {
              this.initMap();
            } else {
              this.map.once('load', this.initMap);
            }
          } else {
            let def = response.body;
            def.expanded = false;
            if (this.query.category === "AUGR") {
              def.entries = [{
                id: 'new',
                aufisn: this.createAufisn,
                definition_id: def.id,
                definition_name: def.name,
                name: def.name,
                description: "",
                properties: {},
                last_worked_at: null,
                estimated_next_work: null,
                locations: {
                  locations: []
                },
              }];
              this.subdefinitions.push(def);
              this.subdefinitions.sort((a, b) => a.name.localeCompare(b.name));
              if (!this.selectedEntity.definitions) {
                this.selectedEntity.definitions = [];
              }
              this.selectedEntity.definitions.push(def);
              let indices = this.findSelection(this.cadastres, def.id, "new", this.toplevelDefinition.id);
              if (indices.length > 0) {
                this.selectionChanged({
                  lastSelection: {
                    selectionId: this.selectedDefinition ? this.selectedDefinition.id : undefined,
                  },
                  currentSelection: {
                    indices: indices,
                    selectionId: def.id + "-new"
                  }
                });
                this.$refs.cadastre_side_menu.setCurrentSelection("new");
              }
            } else {
              def.sub_definitions = [];
              this.cadastres.push(def);
              this.cadastres.sort((a, b) => a.name.localeCompare(b.name));
            }
            this.layers[def.id] = [
              this.getLayer(def.id, undefined, def.color, "Point"),
              this.getLayer(def.id, undefined, def.color, "LineString"),
              this.getLayer(def.id, undefined, def.color, "Polygon"),
              ...this.getSymbolLayers(def.id, def.icon ? def.icon : "")
            ];
            for (const layer of this.layers[def.id]) {
              this.map.on('mouseenter', layer.id, () => {
                if (this.inEditMode) {
                  return
                }
                this.map.getCanvas().style.cursor = 'pointer';
              });
              this.map.on('mouseleave', layer.id, () => {
                if (this.inEditMode) {
                  return
                }
                this.map.getCanvas().style.cursor = '';
              });
            }
          }
        } else {
          //window.location = Redirect_500;
        }
      }, this.responseError)
    },
  }
}
</script>


<style scoped lang="scss">

.sidebar2 {
  visibility: hidden;
  width: 0;
  position: absolute;
  z-index: 1 !important;
  overflow-x: hidden;
  padding: 0;
  top: 50px;
}

.col {
  padding: 12px;
}

.row {
  flex: 1 1 auto;
}

::v-deep .v-snack__content {
  color: white;
}

::v-deep .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
  min-width: 32px;
}

::v-deep .mapboxgl-ctrl-top-left {
  display: flex !important;
}

::v-deep .marker {
  background-image: url('../../../public/mangel_marker.png');
  background-size: cover;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

</style>
